// src/config/adminConfig.js
// Two-tier admin access control using Firebase UIDs
// To find a user's UID: Firebase Console → Authentication → Users → copy UID

// SUPER ADMINS: Full access to everything (analytics, revenue, payments)
export const SUPER_ADMIN_UIDS = [
  'ri1Mo1RSfjgOxLwUZuqfKvvLS8S2',  // Your UID
  // Add more super admin UIDs here
];

// STAFF: Limited access (user table, course info, NO financial data)
export const STAFF_UIDS = [
  'j9lYAGL4m4hbdvw444nYs8NoVpT2',
  // Add teacher/staff UIDs here
  // Example: 'abc123xyz456',
];

// Helper functions
export const isSuperAdmin = (uid) => {
  return SUPER_ADMIN_UIDS.includes(uid);
};

export const isStaff = (uid) => {
  return STAFF_UIDS.includes(uid);
};

export const isAdmin = (uid) => {
  return isSuperAdmin(uid) || isStaff(uid);
};

export const getAdminRole = (uid) => {
  if (isSuperAdmin(uid)) return 'super_admin';
  if (isStaff(uid)) return 'staff';
  return null;
};